import {Box} from '@mui/material'
import {
  DivContainer,
  PromptContainer,
  StyledPromptTypography,
  StyledPaperContainer,
  StyledChatTextField
} from '../ChatViewStyles'
import PropTypes from 'prop-types'
import {ChatButtons} from './ChatButtons'
import chatbotConfig from '../../../../../../configs/askGPChatViewConfig.json'

const ChatPromptArea = ({
  mainPrompt,
  editedPrompt,
  editClicked,
  handleEditClick,
  handleClearClick,
  handleCrossClick,
  handleSendClick,
  textFieldRef,
  setEditedPrompt,
  loader
}) => {
  return (
    <Box>
      <StyledPaperContainer elevation={1} editClicked={editClicked}>
        <PromptContainer editClicked={editClicked}>Your Prompt:</PromptContainer>
        <DivContainer editClicked={editClicked}>
          {editClicked ? (
            <StyledChatTextField
              inputProps={{
                maxLength: chatbotConfig.maxPromptCharLength
              }}
              inputRef={textFieldRef}
              value={editedPrompt}
              onChange={(e) => setEditedPrompt(e.target.value)}
              variant="standard"
              size="small"
              InputProps={{
                disableUnderline: true
              }}
            />
          ) : (
            <StyledPromptTypography>{mainPrompt}</StyledPromptTypography>
          )}
          <ChatButtons
            editClicked={editClicked}
            handleClearClick={handleClearClick}
            handleEditClick={handleEditClick}
            handleSendClick={handleSendClick}
            editedPrompt={editedPrompt}
            mainPrompt={mainPrompt}
            handleCrossClick={handleCrossClick}
            loader={loader}
          />
        </DivContainer>
      </StyledPaperContainer>
    </Box>
  )
}

ChatPromptArea.propTypes = {
  mainPrompt: PropTypes.string.isRequired,
  editedPrompt: PropTypes.string.isRequired,
  editClicked: PropTypes.bool.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleClearClick: PropTypes.func.isRequired,
  handleCrossClick: PropTypes.func.isRequired,
  handleSendClick: PropTypes.func.isRequired,
  textFieldRef: PropTypes.object,
  setEditedPrompt: PropTypes.func.isRequired,
  loader: PropTypes.bool.isRequired
}

export default ChatPromptArea
